import { FIELD_PREVIEWS, getFormFieldLabel } from '@wix/form-fields/preview';
const sortFields = (a, b) => {
  if (typeof a.row !== 'number' || typeof b.row !== 'number' || typeof a.column !== 'number' || typeof b.column !== 'number') {
    return 0;
  }
  if (a.row > b.row) {
    return 1;
  }
  if (a.row < b.row) {
    return -1;
  }
  if (a.column > b.column) {
    return 1;
  }
  if (a.column < b.column) {
    return -1;
  }
  return 0;
};
const getSubmissionValues = (values, fields, includeEmptyValues) => {
  if (!fields) {
    return [];
  }
  return fields.reduce((result, field) => {
    var _field$view;
    const target = field.target;
    if (!target) {
      return result;
    }
    const fieldType = (_field$view = field.view) == null ? void 0 : _field$view.fieldType;
    if (!fieldType) {
      return result;
    }
    const getFieldPreview = FIELD_PREVIEWS[fieldType];
    if (!getFieldPreview) {
      return result;
    }
    if (!values.hasOwnProperty(target)) {
      return result;
    }
    const value = values[target];
    const formatted = getFieldPreview({
      field,
      value
    });
    const label = getFormFieldLabel(field);
    if (formatted) {
      result.push(formatted);
    } else if (includeEmptyValues && label) {
      result.push({
        label,
        value: null
      });
    }
    return result;
  }, []);
};
export const getSubmissionPreview = (form, values, options) => {
  const sortedFields = (form.steps || []).map(step => {
    var _step$layout;
    return (((_step$layout = step.layout) == null || (_step$layout = _step$layout.large) == null ? void 0 : _step$layout.items) || []).sort(sortFields);
  }).flat().reduce((result, item) => {
    var _form$fields;
    const field = (_form$fields = form.fields) == null ? void 0 : _form$fields.find(_ref => {
      let {
        id
      } = _ref;
      return id === item.fieldId;
    });
    if (!field) {
      return result;
    }
    result.push(field);
    return result;
  }, []);
  const submissionValues = getSubmissionValues(values, sortedFields, options == null ? void 0 : options.includeEmptyValues);
  if (options != null && options.includeDeletedFields) {
    const deletedFieldsSubmissionValues = getSubmissionValues(values, form.deletedFields);
    return [...submissionValues, ...deletedFieldsSubmissionValues];
  }
  return submissionValues;
};
//# sourceMappingURL=submission-preview.js.map